function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M51.305,9.983C53.355,7.933 53.355,4.604 51.305,2.554C49.255,0.504 45.926,0.504 43.876,2.554L26.609,19.838L9.325,2.57C7.275,0.521 3.946,0.521 1.896,2.57C-0.154,4.62 -0.154,7.949 1.896,9.999L19.18,27.267L1.912,44.551C-0.137,46.601 -0.137,49.929 1.912,51.979C3.962,54.029 7.291,54.029 9.341,51.979L26.609,34.695L43.893,51.963C45.943,54.013 49.272,54.013 51.321,51.963C53.371,49.913 53.371,46.584 51.321,44.534L34.037,27.267L51.305,9.983Z",
    style: {
      fill: "#ccc",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.d23451f0a9f25b15677944f023d34cc6.svg";